import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the unpaid-invoices screen — shares the View frame with the real content. */
export function UnpaidInvoicesPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
          {/* The real screen puts its CTA here, which is a fixed full-width bar on mobile. Without the
              slot the layout jumps when content lands. */}
          <View.Actions>
            <Skeleton variant="button" width={180} />
          </View.Actions>
        </View.Header>
        <View.Body>
          <div className="flex flex-col gap-stack">
            <Skeleton variant="text" width={180} height={24} />
            <Skeleton variant="block" height={144} />
          </div>

          <div className="flex flex-col items-end gap-20">
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={120} height={28} />
          </div>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
